export default function (time) {
	let D = (time - (time % 1440)) / 1440;
	let H = ((time % 1440) - ((time % 1440) % 60)) / 60;
	let M = time - (D * 1440 + H * 60);
	let resp = '';
	if (D > 0) {
		if (D == 1) resp += `${D} Dia `;
		else resp += `${D} Dias `;
	}
	if (H > 0) {
		if (H == 1) resp += `${H} Hora `;
		else resp += `${H} Horas `;
	}
	if (M > 0) {
		if (M == 1) resp += `${M} Minuto`;
		else resp += `${M} Minutos`;
	}
	if (resp == '') return '0 Minutos';
	return resp;
}



// WEBPACK FOOTER //
// ./src/assets/js/time.js